import { render, staticRenderFns } from "./Pioneros.vue?vue&type=template&id=70c67e4d&"
import script from "./Pioneros.vue?vue&type=script&lang=js&"
export * from "./Pioneros.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports